import {
  Box,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from '@mui/material'
import { useState } from 'react'
import AppDateRangePicker from '@/components/DatePickers/AppDateRangePicker'
import DataGrid from '@/components/Table/DataGrid'
import generalColumns from '@/components/features/config/columns/consumers/general.columns'
import { userRows } from '@/mockdata/usersData'

export type GeneralFilters = {
  from: Date | null
  to: Date | null
  eventType: string
}

const columns = generalColumns

const SensorsGeneral = () => {
  const [filters, setFilters] = useState<GeneralFilters>({
    from: null,
    to: null,
    eventType: '',
  })

  const handleSearch = () => {
  }

  return (
    <Box>
      <Box
        sx={{
          padding: 2,
          borderBottom: '1px solid #E6EEF5',
          backgroundColor: '#FAFBFD',
        }}
      >
        <Box
          dir="rtl"
          sx={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            gap: 2,
            flexWrap: 'wrap',
            justifyContent: 'flex-start',
          }}
        >
          <AppDateRangePicker
            value={{ from: filters.from, to: filters.to }}
            onChange={range => setFilters(prev => ({ ...prev, ...range }))}
            disableFuture
            clearable
          />

          <FormControl size="small" sx={{ minWidth: 180 }}>
            <InputLabel sx={{ fontSize: '14px' }}>סוג אירוע</InputLabel>
            <Select
              value={filters.eventType}
              label="סוג אירוע"
              onChange={e =>
                setFilters(prev => ({ ...prev, eventType: e.target.value }))
              }
              sx={{
                fontSize: '14px',
                '& .MuiOutlinedInput-notchedOutline': {
                  borderColor: '#E0E0E0',
                },
              }}
            >
              <MenuItem value="">התראה, התכלה</MenuItem>
              <MenuItem value="alert">התראה</MenuItem>
              <MenuItem value="consumption">התכלה</MenuItem>
              <MenuItem value="maintenance">תחזוקה</MenuItem>
              <MenuItem value="reading">קריאה</MenuItem>
            </Select>
          </FormControl>
          <Button
            onClick={handleSearch}
            sx={{
              minWidth: 80,
              height: 40,
              borderRadius: '6px',
              bgcolor: '#E3F5FF',
              color: '#0066CC',
              fontWeight: 600,
              fontSize: '14px',
              textTransform: 'none',
              '&:hover': { bgcolor: '#D1EFFF' },
            }}
          >
            חיפוש
          </Button>
        </Box>
      </Box>

      <Box
        sx={{
          padding: 3,
          '& .MuiDataGrid-root': {
            border: 'none',
          },
        }}
      >
        <DataGrid
          columns={columns}
          rows={userRows}
          hideFooter={false}
          pageSize={25}
          checkboxSelection={false}
          width="100%"
          headerPosition="bottom"
        />
      </Box>

    </Box>
  )
}

export default SensorsGeneral
